import { observer } from 'mobx-react-lite';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useStore } from '@shared/hooks/useStore';
import { ADMIN_ROUTES } from '@/shared/configs/constants';

export const GroupAdminGuard = observer(() => {
    const { authStore } = useStore();
    const location = useLocation();

    // Still loading profile
    if (authStore.token && !authStore.profile) {
        return (
            <div className='flex items-center justify-center h-screen'>
                <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-primary'></div>
            </div>
        );
    }

    // Not logged in
    if (!authStore.isLoggedIn) {
        return <Navigate to={ADMIN_ROUTES.login.href} state={{ from: location }} replace />;
    }

    // Check GROUP_ADMIN role
    if (!authStore.isGroupAdmin) {
        return <Navigate to={ADMIN_ROUTES.login.href} replace />;
    }

    return <Outlet />;
});
